import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {
    section_id: false
  },
  mutations: {

  },
  actions: {
    async fetchFilters({ commit, state }, {id, page, filter={}, search='', first=false}) {
      // Проверяем, были ли категории уже загружены
      if (id == undefined)
        return;

      if (state.filter && Object.values(state.filter).length > 0 && state.section_id == id && first) {
        return;
      }

      if (page == 1)
        commit('RESET_STATE');

      state.section_id = id;

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/catalog/filter/'+id+'/', {
          params: {q: search, filter: filter, set_filter: 'Y'}
        });
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    filter: state => state.data,
    filterLoading: state => state.loading,
    filterError: state => state.error,
    filterLoaded: state => state.loaded,
  }
})